module.exports = __webpack_public_path__ + "static/media/Chronic Pain ManagementActive.0ef28d86.svg";